import React from 'react';

const ChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6 3.20006C15.0418 3.53143 15.1314 4.15823 14.8 4.60006L9.25 12.0001L14.8 19.4001C15.1314 19.8419 15.0418 20.4687 14.6 20.8001C14.1582 21.1314 13.5314 21.0419 13.2 20.6001L7.2 12.6001C6.93333 12.2445 6.93333 11.7556 7.2 11.4001L13.2 3.40006C13.5314 2.95823 14.1582 2.86869 14.6 3.20006Z"
      />
    </svg>
  );
};

export default ChevronLeft;
